import { createContext, useContext } from 'react';
import { EMenuOpenType, TMenuColors, TMenuSettings } from './types';
import { DEFAULT_COLORS, DEFAULT_SETTINGS } from './utils';

type TMenuContext = {
  colors: TMenuColors;
  settings: TMenuSettings;
  rtl: boolean;
  open: boolean;
  openType?: EMenuOpenType;
  translation: Record<string, string>;
};

export const MenuContext = createContext<TMenuContext>({
  colors: DEFAULT_COLORS,
  settings: DEFAULT_SETTINGS,
  rtl: false,
  open: false,
  translation: {},
});

export const useMenuContext = () => useContext(MenuContext);
